import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/image/onreturn.png';
import _imports_1 from '../../../assets/image/gold.png';
import _imports_2 from '../../../assets/image/sright.png';
import _imports_3 from '../../../assets/image/convertselect.png';
import _imports_4 from '../../../assets/image/passeyesopn.png';
import _imports_5 from '../../../assets/image/passeyes.png';
const _withScopeId = n => (_pushScopeId("data-v-3fb35572"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tk-user-head"
};
const _hoisted_2 = {
  class: "tk-head-nav flex-between"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-head-title"
}, "额度兑换", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已绑定账号", -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  class: "tk-head-money"
};
const _hoisted_9 = {
  class: "tk-num"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-exchange-num"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", null, "可兑换金币")], -1));
const _hoisted_11 = {
  class: "tk-main-purse-withdraw"
};
const _hoisted_12 = {
  class: "tk-exchange-select-userlottey"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 请选择扣除额度的彩票余额账号", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_15 = [_hoisted_13, _hoisted_14];
const _hoisted_16 = {
  class: "tk-platform"
};
const _hoisted_17 = {
  class: "platform"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "平台：", -1));
const _hoisted_19 = {
  class: "info"
};
const _hoisted_20 = {
  class: "platform"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "账号：", -1));
const _hoisted_22 = {
  class: "info"
};
const _hoisted_23 = {
  class: "platform"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "name"
}, "姓名：", -1));
const _hoisted_25 = {
  class: "info"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})], -1));
const _hoisted_27 = {
  class: "tk-exit-passwrod"
};
const _hoisted_28 = {
  class: "tk-from"
};
const _hoisted_29 = {
  class: "title"
};
const _hoisted_30 = {
  class: "tk-from-field flex-between"
};
const _hoisted_31 = {
  key: 0
};
const _hoisted_32 = {
  class: "tk-field-input"
};
const _hoisted_33 = ["type", "onUpdate:modelValue", "onBlur", "placeholder"];
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  key: 0,
  src: _imports_4,
  alt: ""
};
const _hoisted_36 = {
  key: 1,
  src: _imports_5,
  alt: ""
};
const _hoisted_37 = {
  key: 0,
  class: "forget"
};
const _hoisted_38 = {
  class: "tk-toup-tips"
};
const _hoisted_39 = {
  class: "bottomSelect"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "选择平台账号", -1));
const _hoisted_41 = {
  class: "tk-platform"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  class: "platform"
};
const _hoisted_44 = {
  class: "info"
};
const _hoisted_45 = {
  class: "select"
};
const _hoisted_46 = {
  key: 0,
  src: _imports_3,
  alt: ""
};
import { platUserPlat, platWithdraw, platWithdraw_page } from '@/utils/https/me';
import contactUser from '@/components/me/contactUser.vue';
import { onBeforeMount } from 'vue';
import Dialog from '@/components/mode/message.js';

import { useRouter } from 'vue-router';
import { reactive, toRefs } from 'vue';
export default {
  __name: 'withdraw',
  setup(__props) {
    const router = useRouter();
    let data = reactive({
      from: [{
        type: 'number',
        name: 'username',
        placeholder: '请输入提现金额',
        value: '',
        icon: '提现金额',
        money: true,
        type_c: false
      }, {
        type: 'password',
        name: 'password',
        placeholder: '请输入新密码',
        value: '',
        icon: '资金密码',
        lookeyes: false,
        money: false,
        type_c: 'password'
      }],
      selectplt: {
        plats: {
          name: '图库'
        },
        plat_user_account: '*****',
        plat_user_name: '*****'
      },
      purseList: [],
      id: '',
      showBottom: false,
      info: [],
      withdraw: {
        account_balance: '*'
      },
      gameShow: false,
      is_balance_freeze: JSON.parse(localStorage.getItem('usetInfo')).is_balance_freeze,
      balance: '请联系平台客服，找回资金密码'
    });
    let {
      from,
      money,
      showBottom,
      purseList,
      selectplt,
      withdraw,
      gameShow,
      balance
    } = toRefs(data);
    onBeforeMount(() => {
      platUserPlats();
      platWithdraw_pages();
    });
    let platWithdraw_pages = () => {
      platWithdraw_page().then(res => {
        if (res.data.status == 40000) {
          Dialog(res.data.message);
        } else {
          let datas = res.data.data;
          data.withdraw = datas;
        }
      });
    };
    let platUserPlats = () => {
      //获取列表
      platUserPlat().then(res => {
        if (res.data.status == 40000) {
          Dialog(res.data.message);
        } else {
          let datas = res.data.data;
          data.selectplt = datas[0];
          data.id = datas[0].id;
          datas.forEach((element, index) => {
            if (index == 0) {
              element.select = true;
            } else {
              element.select = false;
            }
          });
          data.purseList.push(...datas);
        }
      });
    };
    let selectLottry = index => {
      //选择平台
      data.purseList.forEach(element => {
        if (element.id == index) {
          element.select = true;
          data.id = '';
          data.selectplt = element;
        } else {
          element.select = false;
        }
        if (element.select == true) {
          data.id = element.id;
        }
      });
      data.showBottom = false;
    };
    let lookPassword = index => {
      if (data.from[index].lookeyes) {
        data.from[index].type = 'password';
        data.from[index].lookeyes = false;
      } else {
        data.from[index].type = 'number';
        data.from[index].lookeyes = true;
      }
    };
    let platWithdraws = from => {
      platWithdraw(from).then(res => {
        if (res.data.status != 40000) {
          Dialog(res.data.message);
          router.back();
          data.from[0].value = '';
          data.from[1].value = '';
        } else {
          Dialog(res.data.message);
        }
      });
    };
    let hanldSubmit = () => {
      if (data.is_balance_freeze == 1) {
        data.balance = '您的资金已经被冻结，请联系客服';
        data.gameShow = true;
        return false;
      }
      let from = {
        user_plat_id: '',
        quota: '',
        fund_password: ''
      };
      from.user_plat_id = data.id;
      from.quota = data.from[0].value;
      from.fund_password = data.from[1].value;
      if (from.user_plat_id == '') {
        Dialog('请选择充值平台');
      } else if (from.quota == '') {
        Dialog('请输入充值金额');
      } else if (from.fund_password == '') {
        Dialog('请输入资金密码');
      } else if (from.quota > Math.floor(data.withdraw.account_balance)) {
        Dialog('输入的金额大于拥有的金额');
      } else {
        platWithdraws(from);
      }
    };
    let returnUp = () => {
      router.back();
    };
    let handleMore = () => {
      //显示弹窗
      data.showBottom = true;
    };
    let handleWjPssword = () => {
      data.gameShow = true;
    };
    let shareShow = () => {
      router.push({
        path: '/me/setup/account'
      });
    };
    let handleBlur = (e, name) => {
      if (name == 'username') {
        if (e > Math.floor(data.withdraw.account_balance)) {
          Dialog('输入的金额大于拥有的金额,请重新输入');
        }
      }
    };
    return (_ctx, _cache) => {
      const _component_botton = _resolveComponent("botton");
      const _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "tk-head-return",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(returnUp) && _unref(returnUp)(...args))
      }, _hoisted_4), _hoisted_5, _createElementVNode("div", {
        class: "tk-head-info",
        onClick: _cache[1] || (_cache[1] = (...args) => _unref(shareShow) && _unref(shareShow)(...args))
      }, _hoisted_7)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(_unref(withdraw).account_balance), 1), _hoisted_10])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: "tk-select-title",
        onClick: _cache[2] || (_cache[2] = (...args) => _unref(handleMore) && _unref(handleMore)(...args))
      }, _hoisted_15), _createElementVNode("div", _hoisted_16, [_createElementVNode("ul", null, [_createElementVNode("li", {
        onClick: _cache[3] || (_cache[3] = $event => _unref(selectLottry)(0))
      }, [_createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(selectplt).plats.name), 1)]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(selectplt).plat_user_account), 1)]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(selectplt).plat_user_name), 1)]), _hoisted_26])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = (...args) => _ctx.onSubmit && _ctx.onSubmit(...args))
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(from), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "labe",
          key: index
        }, [_createElementVNode("div", _hoisted_29, _toDisplayString(item.icon), 1), _createElementVNode("div", _hoisted_30, [item.money ? (_openBlock(), _createElementBlock("span", _hoisted_31, "¥")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_32, [_withDirectives(_createElementVNode("input", {
          type: item.type,
          "onUpdate:modelValue": $event => item.value = $event,
          onBlur: $event => _unref(handleBlur)(item.value, item.name),
          placeholder: item.placeholder
        }, null, 40, _hoisted_33), [[_vModelDynamic, item.value]])]), item.type_c == 'password' ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "tk-field-tips",
          onClick: $event => _unref(lookPassword)(index)
        }, [item.lookeyes ? (_openBlock(), _createElementBlock("img", _hoisted_35)) : (_openBlock(), _createElementBlock("img", _hoisted_36))], 8, _hoisted_34)) : _createCommentVNode("", true)]), !item.money ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("span", {
          onClick: _cache[4] || (_cache[4] = (...args) => _unref(handleWjPssword) && _unref(handleWjPssword)(...args))
        }, "忘记密码")])) : _createCommentVNode("", true)]);
      }), 128))], 32)])]), _createElementVNode("div", {
        class: "tk-botton",
        onClick: _cache[6] || (_cache[6] = (...args) => _unref(hanldSubmit) && _unref(hanldSubmit)(...args))
      }, [_createVNode(_component_botton, {
        name: "提现",
        bgcolor: _unref(data).from[1].value == '' ? 'rgba(63, 40, 96, 0.4);' : '#3f2860'
      }, null, 8, ["bgcolor"])])]), _createElementVNode("div", _hoisted_38, [_createElementVNode("p", null, " 温馨提示：1.用户一天可提现" + _toDisplayString(_unref(withdraw).withdraw_num) + "次,一次提现最低金额" + _toDisplayString(_unref(withdraw).withdraw_min_each) + "元,最高" + _toDisplayString(_unref(withdraw).withdraw_max) + "元一天累计提现不超过" + _toDisplayString(_unref(withdraw).withdraw_max_each) + "元;2.用户提现时需要支付" + _toDisplayString(_unref(withdraw).withdraw_rate) + "%手续费。 ", 1)])]), _createVNode(_component_van_popup, {
        show: _unref(showBottom),
        "onUpdate:show": _cache[7] || (_cache[7] = $event => _isRef(showBottom) ? showBottom.value = $event : showBottom = $event),
        round: "",
        position: "bottom",
        style: {
          height: '30%'
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_39, [_hoisted_40, _createElementVNode("div", _hoisted_41, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(purseList), (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            onClick: $event => _unref(selectLottry)(item.id)
          }, [_createElementVNode("div", _hoisted_43, [_createElementVNode("span", _hoisted_44, _toDisplayString(item.plats.name), 1)]), _createElementVNode("div", _hoisted_45, [item.select ? (_openBlock(), _createElementBlock("img", _hoisted_46)) : _createCommentVNode("", true)])], 8, _hoisted_42);
        }), 128))])])])]),
        _: 1
      }, 8, ["show"]), _createVNode(contactUser, {
        show: _unref(gameShow),
        "onUpdate:show": _cache[8] || (_cache[8] = $event => _isRef(gameShow) ? gameShow.value = $event : gameShow = $event),
        title: _unref(balance)
      }, null, 8, ["show", "title"])], 64);
    };
  }
};